// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"bodyWrapper-W2xHQ","button":"button-rysDo"};